import { FC } from "react";
import { Image, ImageProps } from "expo-image";

export const VnImage: FC<ImageProps> = ({ contentFit = "cover", ...props }) => {
  return <Image contentFit={contentFit} {...props} />;
};
